var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M19,23H2a1,1,0,0,1-1-1V5A1,1,0,0,1,2,4h8V6H3V21H18V14h2v8A1,1,0,0,1,19,23Z"}}),_c('polygon',{attrs:{"points":"20 0.586 8.126 12.46 6.419 17.581 11.54 15.874 23.414 4 20 0.586"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }